import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserPreferences,
  updateUserPreferences,
  clearUserPreferencesOperationResult
} from "../store/userPreference/userPreferenceActions";
import openNotificationOperationResult from "../components/shared/openNotificationOperationResult";

const useUserPreferences = (keys) => {
  const dispatch = useDispatch();
  const dispatchedRef = useRef(false);
  const { data, loading, operationResult } = useSelector((state) => state.userPreference);
  const [editablePreferences, setEditablePreferences] = useState({});

  // 1. Use existing stored preferences immediately
  useEffect(() => {
    if (data) {
      setEditablePreferences((prev) => ({
        ...prev,
        ...data,
      }));
    }
  }, [data]);

  // 2. Always re-fetch to keep data current
  useEffect(() => {
    if (!dispatchedRef.current && keys.length > 0) {
      dispatchedRef.current = true;
      dispatch(getUserPreferences(keys));
    }
  }, [dispatch, keys]);

  // 3. Notification logic
  useEffect(() => {
    if (operationResult) {
      openNotificationOperationResult(operationResult, () => {
        dispatch(clearUserPreferencesOperationResult());
      });
    }

    return () => {
      dispatch(clearUserPreferencesOperationResult());
    };
  }, [operationResult, dispatch]);

  const setEditablePreference = (key, value) => {
    setEditablePreferences((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const savePreferences = (preferencesToSave, brokerId = null) => {
    dispatch(updateUserPreferences({
      Preferences: preferencesToSave,
      BrokerId: brokerId
    }));
  };

  return {
    preferences: editablePreferences,
    setEditableUserPreference: setEditablePreference,
    saveUserPreferences: savePreferences,
    loading,
  };
};

export default useUserPreferences;
